var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "files-container" },
    _vm._l(_vm.files, function (file) {
      return _c("FileCard", {
        key: file._id,
        attrs: { file: file, selected: _vm.isFileSelected(file) },
        on: {
          doubleClick: _vm.handleDoubleClick,
          delete: _vm.handleDelete,
          toggleSelection: function ($event) {
            return _vm.$emit("fileSelect", $event)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }